import React from 'react';
import { skills } from '../data/mock';
import { Progress } from './ui/progress';
import { useLanguage } from '../context/LanguageContext';

const Skills = () => {
  const { t } = useLanguage();

  return (
    <section id="skills" className="py-32 px-6 relative bg-[hsl(270,50%,4%)]">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[150px]" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20">
          <span className="text-purple-400 font-mono text-sm tracking-wider uppercase">{t('skills.label')}</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6 text-white">
            {t('skills.title')} <span className="gradient-text">{t('skills.titleHighlight')}</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-fuchsia-500 mx-auto rounded-full" />
        </div>

        {/* Skills grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {skills.map((skill, index) => (
            <div 
              key={index}
              className="group p-6 rounded-2xl bg-[hsl(270,40%,8%)] border border-purple-500/10 hover:border-purple-500/30 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-lg font-semibold text-white group-hover:text-purple-300 transition-colors duration-300">
                  {skill.name}
                </span>
                <span className="text-purple-400 font-mono text-sm">{skill.level}%</span>
              </div>
              <Progress 
                value={skill.level} 
                className="h-2 bg-purple-900/30"
              />
            </div>
          ))}
        </div>

        {/* Tech logos decoration */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 opacity-50">
          {['JavaScript', 'React', 'Node.js', 'TypeScript', 'MongoDB', 'Git'].map((tech, i) => (
            <div 
              key={i}
              className="px-6 py-3 rounded-xl border border-purple-500/20 text-purple-300 font-mono text-sm hover:border-purple-500/50 hover:text-purple-200 transition-all duration-300 cursor-default"
            >
              {tech}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
